import { Route, Routes, Navigate } from 'react-router-dom';

import { ChartPage } from './pages/ChartPage';
import { ProfilePage } from './pages/ProfilePage';

/**
 * LIFF 單 SPA 但有兩個路由。LINE Developer Console 要建兩個 LIFF App：
 *   - tianyun-chart   endpoint: https://liff.tianyun.app/chart
 *   - tianyun-profile endpoint: https://liff.tianyun.app/profile
 *
 * VITE_LIFF_ID_CHART / VITE_LIFF_ID_PROFILE 分別注入 build 時。
 */
export function App() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/chart" replace />} />
      <Route
        path="/chart"
        element={<ChartPage liffId={import.meta.env.VITE_LIFF_ID_CHART} />}
      />
      <Route
        path="/profile"
        element={<ProfilePage liffId={import.meta.env.VITE_LIFF_ID_PROFILE} />}
      />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

function NotFound() {
  return (
    <main className="flex min-h-screen items-center justify-center p-6 text-center">
      <div>
        <h1 className="font-serif text-xl font-bold">找不到頁面</h1>
        <p className="mt-2 text-sm text-ink/70">請從 LINE Rich Menu 重新進入。</p>
      </div>
    </main>
  );
}
